<template>
    <f7-page>
        <f7-navbar :sliding="false">
            <f7-nav-left>
                <f7-link icon-ios="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
            </f7-nav-left>
            <f7-nav-title sliding>JKAnimeAPP</f7-nav-title>
        </f7-navbar>

        <f7-searchbar
                disable-button-text="Cancelar"
                placeholder="Buscar anime"
                v-on:submit="search"
                @searchbar:search="onSearch"
                :custom-search="true"
                :clear-button="true"
        ></f7-searchbar>

        <f7-toolbar bottom tabbar id="toolbar" class="tabbar-labels">
            <f7-link class="bottom-tab" tab-link="#recientes" tab-link-active>
                <i class="material-icons">schedule</i>
                <span class="tabbar-label">Recientes</span>
            </f7-link>
            <f7-link class="bottom-tab" tab-link="#portada">
                <i class="material-icons">toc</i>
                <span class="tabbar-label">Portada</span>
            </f7-link>

            <f7-link class="bottom-tab" tab-link="#top">
                <i class="material-icons">star</i>
                <span class="tabbar-label">Top</span>
            </f7-link>


        </f7-toolbar>

        <f7-tabs class="tabs" swipeable>
            <f7-tab id="recientes" tab-active>
                <recientes-page :datos.sync="recientes"></recientes-page>
            </f7-tab>
            <f7-tab id="portada">
                <lista-animes-page :datos.sync="portada"></lista-animes-page>
            </f7-tab>
            <f7-tab id="top">
                <lista-animes-page :datos.sync="top"></lista-animes-page>
            </f7-tab>
        </f7-tabs>

    </f7-page>

</template>
<script>
    import recientes from './recientes'
    import listaAnime from './listaAnime'
    import image from "../img/fondo.png"
    import logo from "../img/ic_launcher.png"

    export default {

        data() {
            return {
                datosUsuario: {},
                recientes: [],
                portada: [],
                top: [],
                query: "",
                image: image,
                logo: logo,
            }
        },
        computed: {
            letters() {
                let letters = [];
                for (let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++) {
                    letters.push(String.fromCharCode([i]))
                }
                return letters
            }
        },
        components: {
            'recientes-page': recientes,
            'lista-animes-page': listaAnime,
        },
        methods: {
            cargarPortada() {
                let self = this;
                self.$f7.preloader.show();
                this.$f7.request.json('https://www.jkanimeapp.com/ios/api.php?action=portada', function (data) {
                    self.recientes = data.response.recientes;
                    self.portada = data.response.portada;
                    self.datosUsuario = data.user;
                    self.top = data.user.TopAnime;

                    self.$f7.preloader.hide();
                });
            },
            onSearch(searchbar, query, previousQuery) {
                this.query = query;
            },
            search() {
                this.$f7router.navigate('/animes/buscar/' + this.query, {})
            }
        },
        mounted() {
            this.cargarPortada();
        }
    }
</script>
